<template>
  <section class="dashboard">
    <Header />
    <div class="dashboard__main_container">
      <div class="dashboard__filters">
        <div class="dashboard__select_container">
          <span class="dashboard__filter_icon">
            <BuildingIcon color="#74787b" />
          </span>
          <v-select solo flat item-text="name" item-value="id" @input="updateSelectedLocation"
            v-model="selectedLocation" :items="locations">
          </v-select>
        </div>
        <!--div class="dashboard__select_container">
          <span class="dashboard__filter_icon"><UsersIcon color="#74787b"/></span>
          <v-select
              solo
              flat
              item-text="name"
              item-value="id"
              @input="updateSelectedUser"
              v-model="selectedUser"
              :items="users">
          </v-select>
        </div> -->
        <div class="dashboard__select_container">
          <span class="dashboard__filter_icon">
            <CalendarIcon color="#74787b" />
          </span>
          <VueDatePicker @input="updateDateRange" no-calendar-icon v-model="dateRange" range label="Rango de Fechas"
            format="DD/MM/YYYY">
            <p>{{ dateRange }}</p>
          </VueDatePicker>
          <span v-if="dateRange" @click="clearDateRange" class="dashboard__clear_datepicker">
            <CancelIcon />
          </span>
        </div>
      </div>
      <section class="dashboard__general_container">

        <div class="dashboard__stats_container">
          <template v-if="generalStats">
            <InvitationCard status="created" text="Invitaciones Creadas" :statusCount="generalStats.created" />
            <InvitationCard status="approved" text="Invitaciones Aprobadas" :statusCount="generalStats.approved" />
            <InvitationCard status="denied" text="Invitaciones Denegadas" :statusCount="generalStats.denied" />
            <InvitationCard status="cancelled" text="Invitaciones Canceladas" :statusCount="generalStats.cancelled" />
            <InvitationCard status="expired" text="Invitaciones Vencidas" :statusCount="generalStats.expired" />
            <InvitationCard status="pending" text="Invitaciones Pendientes" :statusCount="generalStats.pending" />
          </template>
          <template v-else>
            <InvitationCardSkeleton v-for="n in 6" :key="n" />
          </template>

        </div>
        <div class="dashboard__main_content">
          <router-view></router-view>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import DashboardService from "@/services/DashboardService";
import BuildingIcon from "../../shared/icons/BuildingIcon.vue";
import UsersIcon from "../../shared/icons/UsersIcon.vue";
import CalendarIcon from "../../shared/icons/CalendarIcon.vue";
import CancelIcon from "../../shared/icons/CancelIcon.vue";
import Header from "@/components/shared/Header.vue";
import CompanyService from "@/services/CompanyService";
import InvitationCard from "../../dashboard/InvitationCard.vue";
import InvitationCardSkeleton from "../../dashboard/InvitationCardSkeleton.vue";

export default {
  components: {
    BuildingIcon,
    UsersIcon,
    CalendarIcon,
    CancelIcon,
    Header,
    InvitationCard,
    InvitationCardSkeleton
  },
  data() {
    return {
      locations: [],
      users: [],
      stats: [],
      generalStats: null,
      selectedLocation: null,
      selectedUser: null,
      dateRange: null,
    }
  },
  mounted() {
    if (!this.getCompany) {
      this.getCompanyData()  // this function also calls the getUsers, getLocations and getGeneralStats functions.
      return;
    }
    this.setLoader(true)
    Promise.all([
      this.getUsers(),
      this.getLocations(),
      this.getGeneralStats()
    ])
      .finally(() => {
        this.setLoader(false);
      });
  },
  methods: {
    async getGeneralStats() {
      try {
        const startDate = this.getStartDate ? new Date(this.getStartDate) : undefined;
        const endDate = this.getEndDate ? new Date(this.getEndDate) : undefined;
        if (startDate) {
          startDate.setHours(24, 0, 0, 1);
        }
        if (endDate) {
          endDate.setHours(23, 59, 59, 999);
          endDate.setHours(24, 0, 0, 0);
        }
        const params = {
          location_id: this.getLocation || undefined,
          user_id: this.getUser || undefined,
          start_date: startDate,
          end_date: endDate,
        }
        console.log("General Params!!!!!!")
        console.log(params)
        this.generalStats = await DashboardService.getGeneralStats(params);
      } catch (err) {
        console.error(err);
      }
    },
    async getUsers() {
      try {
        this.users = await DashboardService.getUsers(localStorage.getItem('companyId'));
      } catch (e) {
        console.error(e);
      }
    },
    async getLocations() {
      try {
        const data = { company: { id: parseInt(localStorage.getItem('companyId')) } }
        this.locations = await DashboardService.getLocations(this.encrypt(data).toString());
        this.locations[0].name = `${this.getCompany.attributes.name} General`;
      } catch (e) {
        console.error(e);
      }
    },
    async updateSelectedUser() {
      this.$store.commit('setUser', this.selectedUser);
      this.setLoader(true);
      try {
        await this.getGeneralStats();
      } catch (err) {
        console.error('Error updating user stats:', err);
      } finally {
        this.setLoader(false);
      }
    },
    async updateSelectedLocation() {
      this.$store.commit('setLocation', this.selectedLocation);
      this.setLoader(true);
      try {
        await Promise.all([
          this.fetchInvitationDetails(),
          this.getGeneralStats()
        ]);
      } catch (err) {
        console.error('Error updating location:', err);
      } finally {
        this.setLoader(false);
      }
    },
    async updateDateRange() {
      this.$store.commit('setRangeDate', { start: this.dateRange.start, end: this.dateRange.end });
      this.setLoader(true);
      try {
        await Promise.all([
          this.fetchInvitationDetails(),
          this.getGeneralStats()
        ]);
      } catch (err) {
        console.error('Error updating date range:', err);
      } finally {
        this.setLoader(false);
      }
    },
    async clearDateRange() {
      this.dateRange = null;
      this.$store.commit('setRangeDate', { start: null, end: null });

      this.setLoader(true);
      try {
        await Promise.all([
          this.fetchInvitationDetails(),
          this.getGeneralStats()
        ]);
      } catch (err) {
        console.error('Error clearing date range:', err);
      } finally {
        this.setLoader(false);
      }
    },
    getCompanyData() {
      this.setLoader(true);
      CompanyService.getCompanyInfo(localStorage.getItem('companyId')).then(async (resp) => {
        this.setCompany(resp.data.data);
        await Promise.all([
          this.getUsers(),
          this.getLocations(),
          this.getGeneralStats()
        ])
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.setLoader(false);
      })
    }
  },
}
</script>
